// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PjGq","footer":"styles_footer__BMxpj"};